module.exports = __webpack_public_path__ + "static/media/world_rank.b02d12ed.png";